import React from 'react';
import './LoadingScreen.css';
function LoadingScreen(){
    return(
        <div className='Loading__wrapper'>
            <img src="https://bindhumadhav.in/alumni/assets/img/loading_spinner.gif"/>
            <div>Loading Please Wait...</div>
        </div>
    );
}
export default LoadingScreen;